import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { FirebaseFunctionsService } from 'src/app/services/firebase-functions.service';

@Component({
  selector: 'app-classes',
  templateUrl: './classes.component.html',
  styleUrls: ['./classes.component.scss']
})
export class ClassesComponent implements OnInit {

  userType: string = '';
  isUserClassesEmpty: boolean = true;
  userClasses: Observable<any> | null = null;
  className: string = '';
  classLevel: string[] = [];
  classCode: string = '';
  constructor(private app: AppComponent, private afs:FirebaseFunctionsService) {
    const typeUser = sessionStorage.getItem('userType');
    if (typeUser == 'administrateur') {
      this.app.navigateTo('/admin');
    }
  }

  ngOnInit(): void {
    this.getUserClasses();
  }
  getUserClasses(){
    const uid = sessionStorage.getItem('userId');
    this.afs.getUtilisateur(uid).forEach( user => {
      this.userType = user['typeUtilisateur'];
      if(this.userType != 'enseignant'){
        this.afs.getParticipantClasses(uid).forEach( data => {
          this.isUserClassesEmpty = (data.length == 0)? true: false;
          this.userClasses = (this.isUserClassesEmpty == false)? this.afs.getParticipantClasses(uid): null;
        })
      }else{
        this.afs.getEnseignantClasses(uid).forEach( data => {
          this.isUserClassesEmpty = (data.length == 0)? true: false;
          this.userClasses = (this.isUserClassesEmpty == false)? this.afs.getEnseignantClasses(uid): null;
        });
      }
    });
  }
}
